import React from "react";
import { connect } from "react-redux";
import language from "../../../../language";
import { Table } from "../../../Table";
import { Modal } from "../../../Modal";
import { Loading } from "../../../Loader";
import api from "../../../../utils/api";
import toastMessage from "../../../../utils/toastMessage";

// eslint-disable-next-line no-unused-vars
let csvData = [];

// eslint-disable-next-line no-unused-vars
class Result extends React.Component {
  state = {
    showItem: {},
  };

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].center,
        key: "center.name",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].center_site,
        key: "centerSite.name",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].donor_number,
        key: "donor.donorNumber",
      },
      {
        title: language[this.props.defaultLanguage].address,
        key: "address",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].eligible,
        key: "isEligible",
        type: "status",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].date,
        key: "requestedDate",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].category,
        key: "category",
        type: "status",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].occupation,
        key: "occupation",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].are_you_married,
        key: "areYouMarried",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title:
          language[this.props.defaultLanguage].are_feeling_healthy_and_well,
        key: "areYouFeelingHealthAndWell",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title:
          language[this.props.defaultLanguage].are_you_taking_any_medication,
        key: "areYouTakingAnyMedication",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title:
          language[this.props.defaultLanguage]
            .do_you_have_any_wound_or_cutaneous_disease,
        key: "doYouHaveAnyWoundOrCutaneousDisease",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title:
          language[this.props.defaultLanguage]
            .did_you_travel_outside_rwanda_recently,
        key: "didYouRecentlyTravelOutsideRwandaRecently",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].have_you_had_malaria,
        key: "haveYouHadMalaria",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].vaccine,
        key: "vaccine",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].dental_extraction,
        key: "dentalExtraction",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title:
          language[this.props.defaultLanguage]
            .continuous_low_grade_fever_any_disease,
        key: "continuousLowGradeFeverOrAnyDisease",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].tattooing_or_ear_piercing,
        key: "tattooingOrEarPiercing",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].surgery_or_circumcision,
        key: "surgeryOrCircumcision",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].endoscopy,
        key: "endoscopy",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].hadBloodTransfusion,
        key: "bloodTransfusion",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].heart_disease,
        key: "heartDisease",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].kidney_disease,
        key: "kidneyDisease",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].cancer,
        key: "cancer",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].diabetes,
        key: "diabetes",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].tuberculosis,
        key: "tuberculosis",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].tuberculosis,
        key: "abnormal_bleeding_tendency",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].asthma,
        key: "asthma",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].hepatitis_b_or_c,
        key: "hepatitisBOrC",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].HIVAIDS,
        key: "HIVAIDS",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].gonorrhea,
        key: "gonorrhea",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title:
          language[this.props.defaultLanguage]
            .neighbor_with_infectious_such_as_hapatitis_b_or_c,
        key: "neighborWithInfectious",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].are_you_pregnant,
        key: "areYouPregnant",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title:
          language[this.props.defaultLanguage]
            .do_you_have_a_child_who_is_under_9_months,
        key: "doYouHaveChildUnder9Months",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title:
          language[this.props.defaultLanguage]
            .do_you_have_a_child_who_is_under_9_months,
        key: "haveYouHadAbortionInTheLastSixMonths",
        styles: {
          textTransform: "uppercase",
        },
      },

      {
        title: language[this.props.defaultLanguage].weight_loss,
        key: "weightLoss",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].swollen_glands,
        key: "swollenGlands",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].syphillis,
        key: "syphillis",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].repeated_diarrhea,
        key: "repeatedDiarrhea",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].are_you_menstrual_period,
        key: "areYouMenstrualPeriod",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].epilepsy,
        key: "epilepsy",
        styles: {
          textTransform: "uppercase",
        },
      },
    ];

    return headers;
  }

  renderTable = () => {
    return (
      <>
        <Table
          page={this.props.page}
          limit={this.props.limit}
          search_text={this.state.search_text}
          // filters={[
          //   {
          //     type: "button",
          //     title: language[this.props.defaultLanguage].generate_report,
          //     onPress: () => {
          //       this.props.handleExport(this.returnTableHeaders());
          //     },
          //     button_type: "button",
          //   },
          // ]}
          handlePagination={this.props.handlePagination}
          data={this.props.data}
          headers={this.returnTableHeaders()}
          totalPageCount={this.props.totalPageCount}
        />
        <Modal
          show={this.props.isExporting}
          handleClose={this.props.handleClose}
        >
          <center>
            <Loading />
          </center>
        </Modal>
      </>
    );
  };

  handleExport = async () => {
    try {
      this.setState({ isExporting: true });

      const options = {
        method: "GET",
        url: `/preDonationAssessment`,
        params: {
          ...this.props.filters,
          page: 1,
          limit: 100000,
        },
      };

      const { data } = await api(options);

      console.log("data", data);

      const results = this.props.formatData(data.data);

      this.setState({
        isExporting: false,
      });

      if (results.length === 0) {
        toastMessage(
          "info",
          language[this.props.defaultLanguage].no_data_found
        );

        return;
      }

      const csvHeaders = this.returnTableHeaders().map((item) => ({
        label: item.title,
        key: item.key,
      }));

      csvData = results.slice(0);

      this.setState(
        {
          csvHeaders,
          downloadReady: true,
        },
        () => {
          // Trigger download after state is updated
          setTimeout(() => {
            this.refs.csvDownload?.link.click();
            this.setState({ isExporting: false, downloadReady: false });
          }, 0);
        }
      );
    } catch (error) {
      console.log("error", error);
      this.setState({ isExporting: false });
      toastMessage("error", error);
    }
  };

  render() {
    return <div>{this.renderTable()}</div>;
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(Result);
